import React, {PureComponent} from "react";
import {
  Card,
  CardHeader,
  Container,
  Progress,
  Row,
  Col
} from "reactstrap";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import * as Roles from "../store/actions/roles";
import italianDashboardTranslations from "../translations/dashboard/it.dashboard.json";
import englishDashboardTranslations from "../translations/dashboard/en.dashboard.json";

import Header from "../components/Headers/Header.js";
import {Button} from "react-bootstrap";
import * as actions from "../store/actions/actions";
import {connect} from "react-redux";
import {getClass, getValue} from "../store/actions/dashboardFuncs";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

class Index extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianDashboardTranslations, "it");
    this.props.addTranslationForLanguage(englishDashboardTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchUserStats();
    this.props.fetchBankStats();
    this.props.fetchFileStats();
    this.props.fetchFiles();
    this.props.fetchBanks();
  }

  render() {

    let userStats=this.props.userStats;
    let bankStats=this.props.bankStats;
    let fileStats = this.props.fileStats;
    // let files=this.props.files;
    let usersInfo = <div>
      <div className="card card-stats">
        <div className="card-body">
          <div className="row">
            <div className="col">
              <h5 className="card-title text-uppercase text-muted mb-0">
                <Translate id="dashboard.users" />
              </h5>
              <span className="h2 font-weight-bold mb-0">
                <Translate id="dashboard.users.total" data={{ userStats: userStats !== null ? userStats.users : 'NA' }}/>
              </span>
            </div>
            <div className="col-auto">
              <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                <i className="ni ni-single-02 text-yellow" />
              </div>
            </div>
          </div>
          <p className="mt-3 mb-0 text-sm">
            <span className=" mr-2">
              <Translate id="dashboard.users.enabled" data={{ userStats: userStats !== null ? userStats.enabled : 'NA' }}/>
            </span>
          </p>
          <p className="mt-3 mb-0 text-sm">
            <span className="text-success mr-2"></span>
          </p>
        </div>
      </div>
    </div>

    let bankCount= Roles.getBankCount(this.props.banks)
    let bankInfo = Roles.isPayDoAdmin(this.props.role) === false ? ""
        : <div >
          <div className="card card-stats">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    <Translate id="dashboard.banks" />
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                <Translate id="dashboard.banks.total" data={{ bankCount: bankCount !== null ? bankCount : 'NA' }}/>
              </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-green text-white rounded-circle shadow">
                    <i className="ni ni-building text-red" />
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-sm">
            <span className=" mr-2">
              <Translate id="dashboard.banks.enabled" data={{ bankCount: userStats !== null ? bankCount : 'NA' }}/>
            </span>
              </p>
              <p className="mt-3 mb-0 text-sm">
                <span className="text-success mr-2"></span>
              </p>
            </div>
          </div>
        </div>

    let CorporateInfo = <div>
      <div className="card card-stats">
        <div className="card-body">
          <div className="row">
            <div className="col">
              <h5 className="card-title text-uppercase text-muted mb-0">
                <Translate id="dashboard.corporate.campaign"/>
              </h5>
            </div>
            <div className="col-auto">
              <div className="icon icon-shape bg-indigo text-white rounded-circle shadow">
                <i className="ni ni-briefcase-24 text-blue" />
              </div>
            </div>
          </div>
          <p className="mt-3 mb-0 text-sm">
            <span className=" mr-2">
              <Translate id="dashboard.corporate" data={{ bankStats: bankStats !== null ? bankStats.corporates : 'NA' }}/>
            </span>
          </p>
          <p className="mt-3 mb-0 text-sm">
            <span className=" mr-2">
              <Translate id="dashboard.campaign" data={{ bankStats: bankStats !== null ? bankStats.campaigns: 'NA' }}/>
            </span>
          </p>
        </div>
      </div>
    </div>


    let fileInfo = <div>
      <div className="card card-stats">
        <div className="card-body">
          <div className="row">
            <div className="col">
              <h5 className="card-title text-uppercase text-muted mb-0">
                <Translate id="dashboard.file"/>
              </h5>
              <span className="h2 font-weight-bold mb-0">
                <Translate id="dashboard.file.total" data={{ fileStats: fileStats !== null ? fileStats.files : 'NA' }}/>
              </span>
            </div>
            <div className="col-auto">
              <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                <i className="ni ni-archive-2 text-indigo" />
              </div>
            </div>
          </div>
          <p className="mt-3 mb-0 text-sm">
            <span className=" mr-2">
              <Translate id="dashboard.file.month" data={{ fileStats: fileStats !== null ? fileStats.thisMonth : 'NA' }}/>
            </span>
          </p>
          <p className="mt-3 mb-0 text-sm">
            <span className="text-nowrap">
              <Translate id="dashboard.file.approve" data={{ fileStats: fileStats !== null ? fileStats.toApprove : 'NA'  }}/>
            </span>
          </p>
        </div>
      </div>
    </div>


    // let fileProgress = func.getFileProgress(files);

    let progress= {
      text: <Translate id="dashboard.table.progress"/>,
      formatter: (cellContent, row) => (
          <div className="d-flex align-items-center">
            <span className="mr-2">{getValue(row.status)}%</span>
            <div>
              <Progress
                  max="100"
                  value={getValue(row.status)}
                  barClassName={getClass(row.status)}
              />
            </div>
          </div>
      )
    }


    const columns = [
      { dataField: 'originalFileName', text: <Translate id="dashboard.table.file"/>, },
      { dataField: 'status', text: <Translate id="dashboard.table.status"/>, },
      progress
    ];

    let table = this.props.files === null ? null :
        <BootstrapTable bootstrap4 headerClasses="thead-light" classes="align-items-center table-flush" keyField='filename' data={ this.props.files }
                        columns={ columns } pagination={ paginationFactory() }
        />


    return (
        <>
          <Header/>
          <Container className="mt--7" fluid style={{paddingBottom:'10%'}}>
            <Row className="mt-5 mb-xl-0">
              {
                Roles.isPayDoAdmin(this.props.role) === false ? ""
                    : <div className="col-sm">
                      {bankInfo}
                    </div>

              }
              <div className="col-sm">
                {usersInfo}
              </div>
              <div className="col-sm">
                <span>{CorporateInfo}</span>
              </div>
              <div className="col-sm">
                <span>{fileInfo}</span>
              </div>
            </Row>
            <Row className="mt-5">
              <Col className="mb-5 mb-xl-0" xl="12">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="dashboard.file.status"/>
                        </h3>
                      </div>
                      <div className="col text-right">
                        <Button
                            color="primary"
                            href="/file"
                            size="sm"
                        >
                          <Translate id="dashboard.file.view.all"/>
                        </Button>
                      </div>
                    </Row>
                  </CardHeader>
                  {table}
                </Card>
              </Col>

            </Row>
          </Container>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userStats: state.dashboard.userStats,
    bankStats: state.dashboard.bankStats,
    fileStats: state.dashboard.fileStats,
    files:state.file.files,
    banks: state.bank.banks,
    role : state.authentication.authenticatedUser.role
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
    fetchUserStats: () => dispatch({ type: actions.FETCH_USER_STATS_REQUEST }),
    fetchBankStats: () => dispatch({ type: actions.FETCH_BANK_STATS_REQUEST}),
    fetchFileStats: () => dispatch({ type: actions.FETCH_FILE_STATS_REQUEST }),
    fetchFiles: () => dispatch({type:actions.FETCH_FILES_REQUEST})
  };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Index));
